import { render, staticRenderFns } from "./PrintInformationForm.vue?vue&type=template&id=6806f531&scoped=true"
import script from "./PrintInformationForm.vue?vue&type=script&lang=ts"
export * from "./PrintInformationForm.vue?vue&type=script&lang=ts"
import style0 from "./PrintInformationForm.vue?vue&type=style&index=0&id=6806f531&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806f531",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6806f531')) {
      api.createRecord('6806f531', component.options)
    } else {
      api.reload('6806f531', component.options)
    }
    module.hot.accept("./PrintInformationForm.vue?vue&type=template&id=6806f531&scoped=true", function () {
      api.rerender('6806f531', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/PrintInformationForm.vue"
export default component.exports